import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
// const BASE_URL = "http://localhost:8000/api";
// const MAIN_URL = "http://localhost:8000";
const BASE_URL = "https://temp.heiportal.chedroxi.com/api";
const MAIN_URL = "https://temp.heiportal.chedroxi.com";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    MAIN_URL: MAIN_URL,
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "white", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    ThemeColor: "#0D47A1",
    darkMode: false,
    SidebarBg: "",
    navbarColor: "primary",
    internalValue: false,
    setHorizontalLayout: false, // Horizontal layout
    user_profile: {},
    registration_form: {
      first_name: '',
      middle_name: '',
      last_name: '',
      extension_name: '',
      birthday: '',
      sex: '',
      hei: '',
      position: '',
      role_id: '',
      contact_number: '',
      email: '',
      password: '',
      password_confirmation: ''
    },
  default_registration_form: {
      first_name: '',
      middle_name: '',
      last_name: '',
      extension_name: '',
      birthday: '',
      sex: '',
      hei: '',
      position: '',
      role_id: '',
      contact_number: '',
      email: '',
      password: '',
      password_confirmation: ''
    },


    cmsp_form_filters: {
      academic_year: '',
      semester: '',
      stufap_types: [],
      stufap_status: [],
      award_year: '',
      programs: [],
      year_levels: [],
      grant_status: [],
      show_more: false,
    },

    default_cmsp_form_filters: {
      academic_year: '',
      semester: '',
      stufap_types: [],
      stufap_status: [],
      award_year: '',
      programs: [],
      year_levels: [],
      grant_status: [],
      heis: [],
      show_more: false,
    },

    loading: false,
    is_signing_in: false,
    is_authenticated: false,
    total_payroll: 0,
    token: [],
    selected_ay: null,
    selected_sem: null,
    selected_scholarship_type: null,
    rendered_component: null,
    fillers: null,
    showPreloader: false,
    view_grantee_setting: null,
    billing_setting: null,
    selected_grantee_filters: null,
    validation_setting: {
      hei: "",
      heis: [],
      academic_year: "",
      semester: "",
      batch: "",
      grant_status: [],
      scholarship_type: null,
      show_unvalidated_only: false,
    },

    is_list_finalized: false,
    accounting_direct_filter: null,

    selected_active_tes3B_main: null,
    profile_and_signatory: null,
    stufaps_billing_filters: null,

    applied_unifast_filters: {
      academic_year: '',
      semester: '',
      scholarship_type: '',
      billing_batch: '',
      user: {}
    },

    selected_items: [],

    generic_val_filters: {
      academic_year: '',
      semester: '',
      heis: [],
      stufap_types: [],
      programs: [],
      year_levels: [],
      grant_status: [],
      show_more: false,
      show_unvalidated_only: false,
    },
    default_generic_val_filters: {
      academic_year: '',
      semester: '',
      stufap_types: [],
      heis: [],
      programs: [],
      year_levels: [],
      grant_status: [],
      show_more: false,
      show_unvalidated_only: false,
    },

    stufap_types: [],
    generic_val_programs_data: [],
    cmsp_programs_data: [],


    // Dashboard filters for CMSP Scholars
    dashboard_filters: {
      academic_year: '',
      semester: '',
      scholarship_type: '',
      stufap_types: [],
      heis: [],
    },

    generic_validation_dashboard_filters:{
      academic_year: '',
      semester: '',
      scholarship_type: '',
      stufap_types: [],
      heis: [],
    },

    heis_data: [],
  },
  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_THEME_COLOR(state, payload) {
      state.ThemeColor = payload;
    },
    SET_THEME_MODE(state, payload) {
      state.darkMode = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
    SET_SIDEBAR_LAYOUT(state, payload) {
      state.internalValue = payload;
    },
    SET_PRELOADER_STATE(state, payload){
      state.showPreloader = payload;
    },
    AUTHENTICATE(state, payload){
      state.is_signing_in = payload;
    },
    isLoading(state, payload){
      state.loading = payload
    },
    isAuthenticated(state, payload){
      state.is_authenticated = payload;
    },
    setToken(state, payload){
      state.token = payload;
    },
    setUserProfile(state, payload){
      state.user_profile = payload;
    },
    setRequestHeader(state, payload){
      axios.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    },
    setTotalNumberOfPayroll(state, payload){
      state.total_payroll = payload;
    },
    setAccountingSetting(state, payload){
      state.selected_ay = payload.ay;
      state.selected_sem = payload.sem;
      state.selected_scholarship_type = payload.scholarship_type;
    },
    setBillingSetting(state, payload){
      state.billing_setting = payload;
    },
    setRenderedComponent(state, payload){
      state.rendered_component = payload;
    },
    setFormFillers(state, payload){
      state.fillers = Object.assign({}, {});
      state.fillers.academic_years = payload.data.school_years;
      state.fillers.semesters = payload.data.semesters;
      state.fillers.grant_types = payload.data.grant_types;
      state.fillers.grant_types_2 = payload.data.grant_types_2;
      state.fillers.scholarship_types = payload.data.scholarship_types;
      state.fillers.fund_sources = payload.data.fund_sources;
      state.fillers.billing_batches = payload.data.billing_batches;
      state.fillers.heis = payload.data.heis;
      state.fillers.payment_statuses = payload.data.payment_statuses;
      state.fillers.grant_statuses = payload.data.grant_statuses;
      state.fillers.voucher_numbers = payload.data.voucher_numbers;
      state.fillers.ada_numbers = payload.data.ada_numbers;
      state.fillers.nta_numbers = payload.data.nta_numbers;
      state.fillers.courses = payload.data.courses;
      state.fillers.csp_programs = payload.data.csp_programs;
      state.fillers.program_level_codes = payload.data.program_level_codes;
      state.fillers.majors = payload.data.majors;
      state.fillers.year_levels = payload.data.year_levels;
      state.fillers.program_levels = payload.data.program_levels;
      state.fillers.psced_codes = payload.data.psced_codes;
      state.fillers.psced_program_names = payload.data.psced_program_names;
      state.fillers.discipline_codes = payload.data.discipline_codes;
      state.fillers.discipline_clusters = payload.data.discipline_clusters;
      state.fillers.sexes = payload.data.sexes;
      state.fillers.regions = payload.data.regions;
      state.fillers.provinces = payload.data.provinces;
      state.fillers.cities = payload.data.cities;
      state.fillers.barangays = payload.data.barangays;
      state.fillers.districts = payload.data.districts;
      state.fillers.special_groups = payload.data.special_groups;
      state.fillers.special_group_types = payload.data.special_group_types;
      state.fillers.institution_types = payload.data.institution_types;
      state.fillers.billing_batches = payload.data.billing_batches;
      state.fillers.processing_statuses = payload.data.processing_statuses;
      state.fillers.CMSP_validation = payload.data.CMSP_validation;
      state.fillers.stufap_types = payload.data.stufap_types;
      state.fillers.stufap_status = payload.data.stufap_status;
      state.fillers.programs = payload.data.programs;
      state.fillers.active_settings = payload.data.active_settings;


      state.fillers.grant_statuses_v_2 = payload.data.grant_statuses_v_2;
      state.fillers.stufap_types = payload.data.stufap_types;
      state.fillers.programs = payload.data.programs;
      state.fillers.billing_batches_v_2 = payload.data.billing_batches_v_2;
      state.fillers.active_settings = payload.data.active_settings;

    },
    setViewGranteeSetting(state, payload){
      state.view_grantee_setting = payload;
    },
    setSelectedGranteeFilters(state, payload){
      state.selected_grantee_filters = payload;
      if(state.view_grantee_setting){
        state.view_grantee_setting.academic_year = payload.academic_year;
        state.view_grantee_setting.semester = payload.semester;
      }
    },
    setSelectedScholarshipType(state, payload){
      if(state.selected_grantee_filters){
        state.selected_grantee_filters.scholarship_types = [payload];
      }
    },

    setSelectedHEI(state, payload){
      if(state.selected_grantee_filters){
        state.selected_grantee_filters.hei = payload;
        if(state.view_grantee_setting){
          state.view_grantee_setting.hei = payload;
        }
      }
    },

    setValidationSetting(state, payload){
      state.validation_setting = payload;
    },

    setBillingStatus(state, payload){
      state.is_list_finalized = payload;
    },

    setAccountingDirectFilter(state, payload){
      state.accounting_direct_filter = payload;
    },

    setActiveTES3BMain(state, payload){
      state.selected_active_tes3B_main = payload;
    },

    setProfileAndSignatory(state, payload){
      state.profile_and_signatory = payload;
    },

    setStufapsBillingFilters(state, payload){
      state.stufaps_billing_filters = payload;
    },

    SET_UNIFAST_APPLIED_FILTERS(state, payload){
      state.applied_unifast_filters = payload;
    },

    SET_SELECTED_ITEMS_IN_TABLE(state, payload){
      state.selected_items = payload;
    },

    SET_REGISTRATION_FORM(state, payload){
      state.registration_form = payload;
    },

    SET_CMSP_FORM_FILTERS(state,payload){
      state.cmsp_form_filters = payload;
    },

    SET_GENERIC_VAL_FILTERS(state,payload){
      state.generic_val_filters = payload;
    },

    SET_STUFAP_TYPES(state,payload){
      state.stufap_types = payload;
    },

    SET_GENERIC_VAL_PROGRAMS_DATA(state,payload){
      state.generic_val_programs_data = payload;
    },

    SET_CMSP_PROGRAMS_DATA(state,payload){
      state.cmsp_programs_data = payload;
    },

    SET_DASHBOARD_FILTERS(state, payload){
      state.dashboard_filters = payload
    },

    SET_GENERIC_VALIDATION_DASHBOARD_FILTERS(state, payload){
      state.generic_validation_dashboard_filters = payload;
    },

    SET_HEIS_DATA(state, payload){
      state.heis_data = payload;
    },


    clearCredentials(state){
      state.user_profile = Object.assign({}, {});
      state.fillers = Object.assign({}, {});
      state.selected_grantee_filters = null;
      state.view_grantee_setting = null;
      state.billing_setting = null;
      state.validation_setting = {
        hei: "",
        academic_year: "",
        semester: "",
        batch: "",
        scholarship_type: null,
      };
      state.token = [];
      state.is_authenticated = false;
      state = Object.assign({}, {});
      state.Sidebar_drawer = null;
      state.Customizer_drawer = false;
      state.SidebarColor = 'white';
      state.navbarColor = 'primary';
      state.setHorizontalLayout = false;
      state.is_list_finalized = false;
      state.accounting_direct_filter = null
    },
  },
  actions: {
    /**
     * Sign In and Sign Out
     */
    registerAccount(context, payload){
      context.commit('isLoading', true);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          axios.post(`${BASE_URL}/register_account`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
        }, 1000)
      })
    },

    completeRegistration(context, payload){
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          axios.post(`${BASE_URL}/complete_registration`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
        }, 1000)
      })
    },

    signIn(context, payload){
      context.commit('isLoading', true);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          axios.post(`${BASE_URL}/authenticate/user_account`, payload)
          .then((response) => {
            context.commit('isAuthenticated', true);
            context.commit('setToken', response.data);
            resolve(response);
          })
          .catch((error) => {
            context.commit('isAuthenticated', false);
            reject(error);
          })
        }, 1000)
      })
    },


    async authenticateUser({dispatch, commit }, payload){
      await dispatch('signIn', payload);
      await dispatch('getUserInfo', { sign_in_as: payload.sign_in_as })
      .then((response) => {
        let profile = response.data.data.account ? response.data.data.account : response.data.data;
        commit('setUserProfile', profile);
      })
      .catch((error) => {
        console.log(error);
      })
    },

    getRegistrationFormData(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/form_data/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    /*** Getting Current User Info */
    getUserInfo(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/auth/hei/user_info`, { params: payload })
        .then((response) => {
          context.commit('setUserProfile', response.data);
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },
    /** * Getting Current User Info Ends */


    
    adminSignOut({commit, getters}){
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/auth/admin/signout`, null , { headers: {"Authorization" : `Bearer ${getters.token.access_token}`}})
        .then((response) => {
          commit('clearCredentials');
          resolve(response);
        })
        .catch((error) => {
          commit('clearCredentials');
          reject(error);
        });
      })
    },

    /**
     * Sign In and Sign Out End
     */


    /** Grantees Controller  Starts*/
    getGranteesList(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/grantees/get/all`, {params: payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    getSelectedGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/grantee/${payload.id}/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    updateGranteeRecord(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let params = JSON.parse(JSON.stringify(payload));
        axios.put(`${BASE_URL}/ched/admin/routes/grantee/${payload.id}/update`,{
          award_number: payload.award_number,
          award_year: payload.award_year,
          barangay_id: payload.barangay_id,
          birthday: payload.birthday,
          category: payload.category,
          city_id: payload.city_id,
          contact_number: payload.contact_number,
          course_year_level: payload.course_year_level,
          discipline_cluster_id: payload.discipline_cluster_id,
          district_id: payload.district_id,
          email_address: payload.email_address,
          extension_name: payload.extension_name,
          first_name: payload.first_name,
          fund_source_id: payload.fund_source_id,
          grant: payload.grant,
          grant_status: payload.grant_status,
          id: payload.id,
          institution_id: payload.institution_id,
          last_name: payload.last_name,
          lrn: payload.lrn,
          main_program_id: payload.main_program_id,
          middle_name: payload.middle_name,
          program_level_code_id: payload.program_level_code_id,
          program_level_id: payload.program_level_id,
          program_major_id: payload.program_major_id,
          province_id: payload.province_id,
          psced_program_name_id: payload.psced_program_name_id,
          region_id: payload.region_id,
          remarks: payload.remarks,
          scholarship_type_id: payload.scholarship_type_id,
          sex_id: payload.sex_id,
          six_digit_psced_code_id: payload.six_digit_psced_code_id,
          special_group_id: payload.special_group_id,
          special_group_type_id: payload.special_group_type_id,
          status_color: payload.status_color,
          street: payload.street,
          student_number: payload.student_number,
          stufap_id: payload.stufap_id,
          stufap_status: payload.stufap_status,
          stufap_status_id: payload.stufap_status_id,
          two_digit_discipline_code_id: payload.two_digit_discipline_code_id,
          unvalidated_main_program: payload.unvalidated_main_program,
          zip_code: payload.zip_code,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    addGranteeRecord(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let params = JSON.parse(JSON.stringify(payload));
        axios.post(`${BASE_URL}/ched/admin/routes/grantee/new/store`,{
          academic_year: payload.academic_year,
          semester: payload.semester,
          award_number: payload.award_number,
          award_year: payload.award_year,
          barangay_id: payload.barangay_id,
          birthday: payload.birthday,
          category: payload.category,
          city_id: payload.city_id,
          contact_number: payload.contact_number,
          course_year_level: payload.course_year_level,
          discipline_cluster_id: payload.discipline_cluster_id,
          district_id: payload.district_id,
          email_address: payload.email_address,
          extension_name: payload.extension_name,
          first_name: payload.first_name,
          fund_source_id: payload.fund_source_id,
          grant: payload.grant,
          grant_status: payload.grant_status,
          institution_id: payload.institution_id,
          last_name: payload.last_name,
          lrn: payload.lrn,
          main_program_id: payload.main_program_id,
          middle_name: payload.middle_name,
          program_level_code_id: payload.program_level_code_id,
          program_level_id: payload.program_level_id,
          program_major_id: payload.program_major_id,
          province_id: payload.province_id,
          psced_program_name_id: payload.psced_program_name_id,
          region_id: payload.region_id,
          remarks: payload.remarks,
          scholarship_type_id: payload.scholarship_type_id,
          sex_id: payload.sex_id,
          six_digit_psced_code_id: payload.six_digit_psced_code_id,
          special_group_id: payload.special_group_id,
          special_group_type_id: payload.special_group_type_id,
          status_color: payload.status_color,
          street: payload.street,
          student_number: payload.student_number,
          stufap_id: payload.stufap_id,
          stufap_status: payload.stufap_status,
          stufap_status_id: payload.stufap_status_id,
          two_digit_discipline_code_id: payload.two_digit_discipline_code_id,
          unvalidated_main_program: payload.unvalidated_main_program,
          zip_code: payload.zip_code,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    addGranteeToOtherAYandSem(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let params = JSON.parse(JSON.stringify(payload));
        axios.post(`${BASE_URL}/ched/admin/routes/grantee/record/add/to_other`,{
          academic_year: payload.academic_year,
          semester: payload.semester,
          student_id: payload.student_id
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    /** Grantees Controller Ends */
    

    /** Account Profile */
    getAccountProfile(context){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/admin/account&profile`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateAccountProfile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/admin/account&profile/update_info`, null, { params: payload })
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateAccountPassword(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/admin/account&profile/update_password`, null, {params: payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateAccountProfilePhoto(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        let formData = new FormData();
        formData.append('photo', payload);
        axios.post(`${BASE_URL}/admin/account&profile/update_photo`, formData , {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },
    
    /** Account Profile Ends */
    
    /** Dashboard */
    getDashboardForElPr(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/el_pr/dashboard/stats/get`, { params: payload })
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },
    /**Dashboard Ends */


    /** User Notifications */
    getNotifications(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/app/user/notifications/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    /** User Notifications Ends */


    /** Billing Monitoring */
    getGranteesForBillingPerHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/grantees/for_billing/get`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    getAcademicYears(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/academic_years/for_billing/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getSemesters(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/semesters/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    getViewGranteeFormFillers(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/form/fields/filler/active/ay&sem/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    exportListOfHEIs(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/heis/data/export`, {
          responseType: 'blob',
          params: payload
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    exportGranteesPerHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/heis/grantees_data/export`, {
          responseType: 'blob',
          params: payload
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getBillingIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        payload.academic_year = JSON.parse(JSON.stringify(payload.academic_year))
        payload.semester = JSON.parse(JSON.stringify(payload.semester))
        axios.get(`${BASE_URL}/ched/admin/routes/billing/get/index`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    getGranteesForBillingPerHEIV2(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/billing/get/grantees`, {params: payload})
        .then((response) => {
          resolve(response);
          context.commit("isLoading", false);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    generateBillingPerSchool(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/generate/per_hei`, payload)
        .then((response) => {
          resolve(response);
          context.commit("isLoading", false);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    getGranteesListForBillingPerHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/grantees/for_billing/per_hei/get`, {params: payload})
        .then((response) => {
          resolve(response);
          context.commit("isLoading", false);
          if(response.data.grantees && response.data.grantees.length){
            context.commit("setBillingStatus", response.data.grantees[0].is_finalized);
          }
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    removeGranteeFromBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/ched/admin/routes/billing/grantee/delete/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    processTheBillingOfGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/grantee/process/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    declineTheBillingOfGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/grantee/decline`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },



    addGranteeToBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/selected_grantee/add`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    bulkRemoveGranteeFromBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/ched/admin/routes/billing/grantees/bulk/delete`, {params: { ids: payload }})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    bulkProcessGranteeFromBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/grantees/bulk/process`, { ids: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    bulkDeclineTheBillingOfGrantees(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/grantees/bulk/decline`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    finalizeBillingDetails(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/billing/grantees/finalize/list`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    addGranteesToBillingDetails(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/billing/grantees/add/list`, payload)
        .then((response) => {
          resolve(response);
          context.commit("isLoading", false);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    /** Billing Monitoring Ends */


    /** Validation Monitoring Starts */
    getValidationIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        payload.academic_year = JSON.parse(JSON.stringify(payload.academic_year))
        payload.semester = JSON.parse(JSON.stringify(payload.semester))
        axios.get(`${BASE_URL}/ched/admin/routes/validation/get/index`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    getValidationDashboardIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        payload.academic_year = JSON.parse(JSON.stringify(payload.academic_year))
        payload.semester = JSON.parse(JSON.stringify(payload.semester))
        axios.get(`${BASE_URL}/ched/admin/routes/validation/dashboard/index`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    getGranteesListForValidation(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/validation/get/grantees`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    removeGranteesFromHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/remove/grantees`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    downloadValidatedGrantees(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/download/grantees/per_hei`, {
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    updateTESValidationRecord(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/validation_record/update`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    submitValidateGranteeForm(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/validation/update/grantee/record/${payload.id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    unvalidateGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/unvalidate/grantee/${payload.id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    

    uploadForValidationMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append('file', payload.file);
        formData.append('filename', payload.filename);
        formData.append('school_year', payload.filtering_form.academic_year)
        formData.append('semester', payload.filtering_form.semester)
        formData.append('scholarship_type', payload.filtering_form.scholarship_type)

        axios.post(`${BASE_URL}/ched/admin/routes/import/for_validation/masterlist`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    
    downloadUnifastUploadingTemplate(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/download/official_template/for_UNIFAST`,{
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getValidationGranteesIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/tes_billing_all_grantees_get/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    transferUNIFASTGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/transfer/unifast/grantee`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    /**Validation Monitoring Ends */


    /** Accounting Functions Starts */
    getAccountingIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        payload.academic_year = JSON.parse(JSON.stringify(payload.academic_year))
        payload.semester = JSON.parse(JSON.stringify(payload.semester))
        axios.get(`${BASE_URL}/ched/admin/routes/accounting/get/index`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    getAccountingGranteesList(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      context.commit("isLoading", true);
      return new Promise ((resolve, reject) => {
        payload.academic_year = JSON.parse(JSON.stringify(payload.academic_year))
        payload.semester = JSON.parse(JSON.stringify(payload.semester))
        axios.get(`${BASE_URL}/ched/admin/routes/accounting/get/grantees/list`, {params: payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    updateGranteePayment(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/add/grantee/payment/${payload.id}`,{
          payment_status: payload.payment_status,
          payment_date: payload.payment_date,
          remarks: payload.remarks,
          academic_year: payload.academic_year,
          semester: payload.semester,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    bulkUpdateGranteesPayment(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/bulk_update/grantees/payment`,{
          payment_status: payload.payment_status,
          payment_date: payload.payment_date,
          remarks: payload.remarks,
          academic_year: payload.academic_year,
          semester: payload.semester,
          selected_grantees: payload.selected_grantees,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    markAllGranteesAsPaid(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/mark_all/grantees/paid`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    bulkUnpayGrantees(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/bulk_unpay/grantees`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    bulkDeleteGranteesPayment(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/bulk/delete/grantees/payment`,{
          payment_status: payload.payment_status,
          payment_date: payload.payment_date,
          remarks: payload.remarks,
          academic_year: payload.academic_year,
          semester: payload.semester,
          selected_grantees: payload.selected_grantees,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    deleteGranteePayment(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/delete/grantee/payment/${payload.id}`,{
          academic_year: payload.academic_year,
          semester: payload.semester,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    unpayGrantee(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/unpay/grantee/${payload.id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    changeBillingProcessingStatus(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/ched/admin/routes/accounting/billing/mark_as_ready_for_payment`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    /** Accounting Functions Endts */


    /** Filters Starts */

    getFiltersForBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/billing/filters/get`, {params : payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    getFormDataFields(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/form/fields/fillers/get`, {params : payload})
        .then((response) => {
          context.commit('setFormFillers', response)
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },
    /** Filters Ends */


    /** Admin Users Starts */
    getUserRoles(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/user/roles/get`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    getAdminUsers(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/users/get`, {params : payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    deactivateAdminuser(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/user/deactivate/${payload.id}`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    activateAdminuser(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/user/activate/${payload.id}`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    storeAdminuser(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/user/account/store`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateAdminuser(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/user/account/update`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },
    /** Admin Users Ends */

    /** Hei User Account Starts */
    getHeiUserAccounts(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/hei/focals/get`, {params : payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateUserAccountStatus(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/user/account/status/update`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false); 
          reject(error);
        });
      });
    },


    updateHEIUserRoles(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/user/roles/update`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },
    /** Hei User Account Ends */



    /** Hei Starts */
    getHeis(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/ched/admin/routes/recognized/heis/get`, {params : payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    deactivateHei(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/recognized/hei/deactivate/${payload.id}`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    activateHei(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/ched/admin/routes/recognized/hei/activate/${payload.id}`)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateHeiAccount(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/recognized/hei/account/update`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    createHeiAccount(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/recognized/hei/account/create`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    storeHei(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/recognized/hei/store`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    updateHei(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/ched/admin/routes/recognized/hei/update`, payload)
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    
    /** Hei Ends */
    
    /**
     * 
     ** TES-3B starts
     */

     tES3BBillingMainIndexAdmin(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/tes_3B/main/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    tES3BBillingDetailsIndexAdmin(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/tes_3B/details/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    saveTES3BBillingDetailRemarks(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/tes_3B/details/add/remarks`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    deleteTES3BBillingDetailRemarks(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/ched/admin/routes/tes_3B/details/delete/remarks`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    processTES3BBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/tes_3B/details/process`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    cancelProcessedTES3BBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/ched/admin/routes/tes_3B/details/cancel_process`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

  
    exportTES3B(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/ched/admin/routes/tes_3B/details/export`,{
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    /**
     * 
     ** TES-3B ends
     */


    /**
     * 
     ** Admin StuFAPs Start
     * 
     */

     exportAdminStufapsMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/admin/routes/stufaps/masterlist/export`,{
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    
    updateScholarRecord(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/admin/routes/stufaps/update/record/csp`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },
    

    // * Validation State
    lockValidationStateToAllHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/admin/routes/stufaps/update/validation_state/per_hei`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateValidationStatePerHEI(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/admin/routes/stufaps/update/validation_state/per_hei`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateValidationStateScholar(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/admin/routes/stufaps/update/validation_state/per_scholar`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    /**
     * 
     ** Admin StuFAPs End
     */






    /**
     ** HEI Application
     */
     getHeiAccountProfile(context){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/auth/hei/user_info`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateHeiAccountProfilePhoto(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append('photo', payload);
        axios.post(`${BASE_URL}/hei/routes/hei_profile/photo/update`, formData , {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateHeiAccountPassword(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/hei/routes/hei_user/account/update_password`, null, {params: payload})
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    updateHeiAccountProfile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.post(`${BASE_URL}/hei/routes/hei_user/profile/update_info`, null, { params: payload })
        .then((response) => {
          context.commit("isLoading", false);
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    getFormDataForHEIAppFields(context, payload){
       context.commit('setRequestHeader', context.getters.token.access_token);
       return new Promise ((resolve, reject) => {
         axios.get(`${BASE_URL}/hei/routes/filters/fillers/HEI_app/get`, {params : payload})
         .then((response) => {
           context.commit('setFormFillers', response)
           resolve(response);
         })
         .catch((error)=>{
           reject(error);
         });
       });
    },
     
     async heiSigningIn({dispatch, commit, getters },payload){
      await dispatch('getHeiUserInfo', payload)
      .then((response) => {
        commit('isAuthenticated', true);
        commit('setToken', payload.token);
        commit('setUserProfile', response.data);
      })
      .catch((error) => {
        commit('isAuthenticated', false)
        console.log(error);
      })
    },

    
    heiSignOut({commit, getters}){
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/auth/hei/signout`, null , { headers: {"Authorization" : `Bearer ${getters.token.access_token}`}})
        .then((response) => {
          commit('clearCredentials');
          resolve(response);
        })
        .catch((error) => {
          commit('clearCredentials');
          reject(error);
        });
      })
    },

     getHeiUserInfo(context, payload){
      context.commit('AUTHENTICATE', true);
      context.commit('setRequestHeader', payload.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${MAIN_URL}/api/auth/hei/user_info`)
        .then((response) => {
          setTimeout(() => {            
            context.commit('AUTHENTICATE', false);
            resolve(response);
          }, 5000);
        })
        .catch((error)=>{
          context.commit('AUTHENTICATE', false);
          reject(error);
        });
      });
    },
  
    uploadTES3BFile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append('file', payload.file);
        formData.append('filename', payload.filename);
        formData.append('reference_number', payload.reference_number);
        axios.post(`${BASE_URL}/hei/routes/tes_3B/import`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    tES3BBillingMainIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/tes_3B/main/index`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    tES3BBillingDetailsIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/tes_3B/details/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    fetchExistingDegreePrograms(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/tes_3B/existing_degree_programs/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getProfileAndSignatory(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/profile_and_signatory/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    saveProfileAndSignatory(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/profile_and_signatory/set`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },
  
    downloadTES3BTemplate(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/TES3B_TEMPLATE/download`,{
          responseType: 'blob',
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    downloadUNIFASTMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/masterlist/download/unifast`,{
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    createStudentToTES3BBillingDetails(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/tes_3B/details/student/create`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateStudentToTES3BBillingDetails(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/tes_3B/details/student/update`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    deleteStudentToTES3BBillingDetails(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/hei/routes/tes_3B/details/student/delete`, { params: payload } )
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    saveTES3BBillingFile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/tes_3B/create_file`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    updateTES3BBillingFile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/tes_3B/update_file`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    deleteTES3BBillingFile(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/hei/routes/tes_3B/delete_file`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    submitPrintRequest(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${MAIN_URL}/store/print_request`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    uploadBulkUpdateMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append('file', payload.file);
        formData.append('filename', payload.filename);
        formData.append('school_year', payload.filtering_form.academic_year)
        formData.append('semester', payload.filtering_form.semester)
        formData.append('scholarship_type', payload.filtering_form.scholarship_type)

        axios.post(`${BASE_URL}/hei/routes/import/masterlist/for_bulk_update`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },


    storeNewGrantStatus(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/grant_status/new`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },



    /** Stufaps Function Starts */
    getStufapScholarshipIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getStufapGenericValidationIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/for_validation/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    getStufapStudentInfo(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/student_info/get/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    validateCSPScholar(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/stufaps/validate/csp`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    cancelCSPValidation(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/stufaps/unvalidate/csp`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    searchOtherExistingScholarshipData(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/other_scholarships_data/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getStufapTypesDataForGenericValidation(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/stufap_types/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getProgramsDataForGenericValidation(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/program/generic_val/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getCMSPDashboardIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/dashboard/csp`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getGenericValidationDashboardIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/stufaps/dashboard/generic_val/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getGenericValidationDashboardDatatableIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/stufaps/dashboard/datatable/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    exportStufapsMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/stufaps/masterlist/export`,{
          responseType: 'blob',
          params: payload
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    uploadStufapsBulkUpdateMasterlist(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append('file', payload.file);
        formData.append('filename', payload.filename);
        formData.append('school_year', payload.filtering_form.academic_year)
        formData.append('semester', payload.filtering_form.semester)
        formData.append('scholarship_type', payload.filtering_form.scholarship_type)

        axios.post(`${BASE_URL}/hei/routes/stufaps/masterlist/import`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          context.commit("isLoading", false);
          reject(error);
        });
      });
    },

    /** Stufaps Function Ends */

    // * Stufaps Billing Starts

    createBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/main_billing_file/create`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    deleteBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/hei/routes/main_billing_file/delete/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    mainBillingIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/main_billing_files/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    
    billingDetailIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/hei/routes/stufaps/billing/detail/index`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    addScholarToBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/stufaps/scholar/add_to_billing`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    removeScholarToBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.delete(`${BASE_URL}/hei/routes/stufaps/scholar/remove_from_billing`, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },



    // * TES Billing Starts
    getTESBillingIndex(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/hei/routes/tes_billing_all_grantees_get/index`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    autoValidate(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.post(`${BASE_URL}/hei/routes/billing/update/through/el/pr`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    updateTESGranteeBillingInfo(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.put(`${BASE_URL}/hei/routes/certified_list/grante/update_v_2`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    excludeGranteeFromBilling(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/hei/routes/billing/grantee/exclude_v_2/`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    cancelTESValidation(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.put(`${BASE_URL}/hei/routes/validation/cancel`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    // * TES Billing Ends
    
    // * Billing Ends

    /**
     ** HEI Application Ends
     */



    /**
     ** Common Getters
     */
     getAllRoles(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/data_provider/roles/index`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getAllActiveHeisInRegion(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/data_provider/heis/index`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getAllProgramsForCSPScholars(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        axios.get(`${BASE_URL}/data_provider/cmsp/programs/index`)
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },


    searchStufapsProgramsData(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/common/routes/programs/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getMajorsData(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/common/routes/majors/data/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getStufapTypesData(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/common/routes/stufap_types/data/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },

    getUnifastUpdatedStatus(context, payload){
      context.commit('setRequestHeader', context.getters.token.access_token);
      return new Promise ((resolve, reject) => {
        context.commit("isLoading", true);
        axios.get(`${BASE_URL}/common/routes/unifast_status/data/get`, {params : payload})
        .then((response) => {
          resolve(response);
        })
        .catch((error)=>{
          reject(error);
        });
      });
    },
    /**
     ** Common Getters End
     */
  },
  getters: {
    isLoading(state) {
      return state.loading;
    },
    isAuthenticated(state){
      return state.is_authenticated;
    },
    token(state){
      return state.token;
    },
    getUserProfile(state){
      return state.user_profile;
    },
    getTotalNumberOfPayroll(state){
      return state.total_payroll;
    },
    navbarColor(state){
      return state.navbarColor;
    },
    getThemeColor(state){
      return state.ThemeColor;
    },
    getSelectedAY(state){
      return state.selected_ay;
    },
    getSelectedSem(state){
      return state.selected_sem;
    },
    getSelectedScholarshipType(state){
      return state.selected_scholarship_type;
    },
    getAccountingSetting(state){
      return { ay: state.selected_ay, sem: state.selected_sem, scholarship_type: state.selected_scholarship_type };
    },
    getRenderedComponent(state){
      return state.rendered_component;
    },
    getFormFillers(state){
      return state.fillers;
    },
    getViewGranteeSetting(state){
      return state.view_grantee_setting;
    },
    getSelectedGranteeFilters(state){
      return state.selected_grantee_filters;
    },
    getValidationSetting(state){
      return state.validation_setting;
    },
    getBillingSetting(state){
      return state.billing_setting;
    },
    getBillingStatus(state){
      return state.is_list_finalized;
    },
    getAccountingDirectFilter(state){
      return state.accounting_direct_filter;
    },
    getActiveTES3BMain(state){
      return state.selected_active_tes3B_main;
    },
    getProfileAndSignatory(state){
      return state.profile_and_signatory;
    },
    GET_PRELOADER_STATE(state){
      return state.showPreloader;
    },
    IS_AUTHENTICATING(state){
      return state.is_signing_in;
    },
    GET_STUFAPS_BILLING_FILTERS(state){
      return state.stufaps_billing_filters;
    },

    MAIN_URL(state){
      return MAIN_URL;
    },
    GET_UNIFAST_APPLIED_FILTERS(state){
      return state.applied_unifast_filters;
    },
    GET_SELECTED_ITEMS_IN_TABLE(state){
      return state.selected_items;
    },
    GET_REGISTRATION_FORM(state){
      return state.registration_form;
    },
    GET_DEFAULT_REGISTRATION_FORM(state){
      return state.default_registration_form;
    },
    GET_CMSP_FORM_FILTERS(state){
      return state.cmsp_form_filters;
    },
    GET_DEFAULT_CMSP_FORM_FILTERS(state){
      return state.default_cmsp_form_filters;
    },
    GET_GENERIC_VAL_FILTERS(state){
      return state.generic_val_filters;
    },

    GET_DEFAULT_GENERIC_VAL_FILTERS(state){
      return state.default_generic_val_filters;
    },

    GET_STUFAP_TYPES(state){
      return state.stufap_types;
    },

    GET_GENERIC_VAL_PROGRAMS_DATA(state){
      return state.generic_val_programs_data;
    },

    GET_CMSP_PROGRAMS_DATA(state){
      return state.cmsp_programs_data;
    },

    GET_DASHBOARD_FILTERS(state){
      return state.dashboard_filters
    },

    GET_GENERIC_VALIDATION_DASHBOARD_FILTERS(state){
      return state.generic_validation_dashboard_filters
    },

    GET_HEIS_DATA(state){
      return state.heis_data;
    },

    APP_BASE_URL(state){
      return state.MAIN_URL;
    }
  },

  modules: {},
  plugins: [createPersistedState({
    storage: window.localStorage
    // storage: window.sessionStorage
})],
});
